._CommunityDetails_hh876_1 {
  /* Empty file & class, used as a placeholder for future styling */
}